var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
import { useSiteOwnerName } from '../hooks/use-site-owner-name';
import { compact } from 'lodash';
// const autoMessages: ChatMessageSpec = 
export var defaultChatConfig = {
  autoPrompts: [],
  autoPromptsTitle: 'Or select a topic that may interest you:'
};
export var ChatContext = React.createContext(defaultChatConfig);
export var ChatProvider = createInheritedProvider(ChatContext, 'replace');
export var useChat = function () {
  var siteOwner = useSiteOwnerName();
  var context = React.useContext(ChatContext);
  var autoPrompts = compact(context.autoPrompts) || compact([siteOwner && {
    id: '<%= siteOwner %>',
    type: 'text',
    values: {
      question: "Tell me about <%= siteOwner %>"
    }
  }]);
  return __assign({
    autoPrompts: autoPrompts
  }, context);
};